var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.6349 12.4092V10.8733H6.64129C6.46715 10.8733 6.32597 11.0145 6.32597 11.1886V16.716H28.4016V11.1886C28.4016 11.0145 28.2604 10.8733 28.0863 10.8733H23.2268V12.4092H21.3349V10.8733H13.5268V12.4092H11.6349ZM21.3349 8.98144H13.5268V5.5918H11.6349V8.98144H6.64129C5.42228 8.98144 4.43408 9.96964 4.43408 11.1886V28.8749C4.43408 30.0939 5.42228 31.0821 6.64129 31.0821H28.0863C29.3053 31.0821 30.2935 30.0939 30.2935 28.8749V11.1886C30.2935 9.96964 29.3053 8.98144 28.0863 8.98144H23.2268V5.5918H21.3349V8.98144ZM6.32597 18.6079V28.8749C6.32597 29.049 6.46715 29.1902 6.64129 29.1902H28.0863C28.2604 29.1902 28.4016 29.049 28.4016 28.8749V18.6079H6.32597ZM11.9083 22.6236H9.92393V20.7317H11.9083V22.6236ZM25.7992 22.6236H14.5142V20.7317H25.7992V22.6236ZM9.92393 26.9857H14.7084V25.0938H9.92393V26.9857ZM17.431 26.9857H18.9725V25.0938H17.431V26.9857ZM21.8303 26.9857H25.7992V25.0938H21.8303V26.9857Z",
  fill: "white"
});

function SvgEvent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/Event.da20dcf7.svg";
export { ForwardRef as ReactComponent };